import { Container, Section, ThemePanel } from "@radix-ui/themes";
import { Wrapper } from "./Wrapper";

const ENV = process.env.REACT_APP_ENVIRONMENT || "NONE";

function App() {
  return (
    <div className="background">
      <Section px="3">
        <Container>
          <Wrapper />
          {ENV === "DEV" && <ThemePanel />}
        </Container>
      </Section>
    </div>
  );
}

export default App;
